import request from '@/utils/request'

/** 待审核付款申请数量（侧栏角标） */
export function fetchPaymentApplyPendingCount() {
  return request({
    url: '/fin/payment-application/pending-count',
    method: 'get'
  })
}

export function fetchList(params) {
  return request({
    url: '/fin/payment-application/list',
    method: 'get',
    params: params
  })
}

export function createApplication(data) {
  return request({
    url: '/fin/payment-application/create',
    method: 'post',
    data: data
  })
}

export function approveApplication(id, status, remark) {
  return request({
    url: '/fin/payment-application/approve/' + id,
    method: 'post',
    params: { status, remark }
  })
}

/** 管理员：撤销已通过审核的订单请款 */
export function adminRevokeApprovedApplication(id) {
  return request({
    url: '/fin/payment-application/admin-revoke-approved/' + id,
    method: 'post'
  })
}



// WEBPACK FOOTER //
// ./src/api/finPaymentApplication.js